import React from 'react';
import styled from '@emotion/styled';
import { getCurrencySymbol, getYandexStoreImageMin } from '../../../helpers';
import Editable from '../../common/Editable';
import Checkbox from '../../common/Checkbox';
import numeral from 'numeral';

const Wrapper = styled('tr')`
  font-size: 14px;
  height: 90px;
  strong {
    display: block;
    color: #323a46;
  }

  td {
    padding-top: 15px;
    padding-bottom: 15px;
    height: 90px;
  }
  .link {
    display: block;
    color: #323a46;
    font-size: 14px;
  }
  .image-block {
    height: 50px;
    width: 70px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
  .custom-badge {
    font-size: 11px;
    line-height: 11px;
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
  }
  .fe-trash-2 {
    font-size: 18px;
    cursor: pointer;
  }
`;

const Link = styled('a')`
  span {
    cursor: pointer;
  }
`;

const TableRow = (props) => {
  const {
    item,
    handleRemoveItem,
    handleUpdateOptional = () => false,
    currentQuantityInput,
    currentQuantityInputValue,
    handleToggleQuantityInput,
    handleUpdateQuantity,
    setCurrentQuantityInputValue,
    setCurrentQuantityInput,
    i,
    allowVariativeBundles = false,
    isNew,
    openItem,
    variative = false,
  } = props;

  return (
    <>
      <Wrapper>
        <td>
          <div
            className="image-block"
            style={{
              backgroundImage: `url(${getYandexStoreImageMin(item.images?.[0]?.url, 100)})`,
            }}
          />
        </td>
        <td>
          <Link onClick={() => openItem(item.productId)}>
            <span className="link table-item-title">{item.shortName}</span>
          </Link>
          <span className="text-muted" style={{ fontSize: '12px' }}>
            {item.variantId}
            {item.extId ? `(${item.extId})` : null}
          </span>
        </td>
        <td>
          {!item.stockAvailable && <span className="custom-badge badge-danger">Отсутствует</span>}
        </td>
        <td>{`${numeral(+item.price).format('0,0.[00]')} ${getCurrencySymbol('RUB')}`}</td>
        <td>
          <>
            {isNew ? (
              <span>{item.quantity}</span>
            ) : (
              <Editable
                value={
                  currentQuantityInput === item.variantId
                    ? currentQuantityInputValue
                    : item.quantity
                }
                currentInput={currentQuantityInput === item.variantId}
                toggleInput={() => handleToggleQuantityInput(item)}
                handleUpdate={() => handleUpdateQuantity(currentQuantityInputValue, i)}
                onChange={(e) => setCurrentQuantityInputValue(e.target.value)}
                handleCancel={() => setCurrentQuantityInput(null)}
              />
            )}
            <div>остаток: {item.stockAvailable}шт.</div>
          </>
        </td>
        {variative && allowVariativeBundles && !isNew && (
          <td className="d-flex justify-content-center align-items-center">
            <Checkbox
              id={`necessaryItem-${item.variantId}`}
              checked={!item.optional}
              onChange={(e) => handleUpdateOptional(e.target.checked, i)}
            />
          </td>
        )}
        <td>
          <div className="item-remove" onClick={() => handleRemoveItem(item, i)}>
            <i className="fe-trash-2" />
          </div>
        </td>
      </Wrapper>
    </>
  );
};

export default TableRow;
